export default __webpack_public_path__ + "static/media/it29.a1e9baee.png";